import { axios } from './config';

//  获取公司信息
export function getCompanyInfo() {
  return axios.get('/companybaseinfo/list_all');
}

//  获取区域列表
export function getDangerList() {
  return axios.get('/dangerinfo/all_list');
}
